<script setup>
import AppPlaceholder from '@/components/UI/AppPlaceholder/AppPlaceholder.vue'
</script>

<template>
  <div class="default-header__skeleton">
    <div class="default-header__skeleton__title">
      <app-placeholder />
    </div>
    <div class="default-header__skeleton__statistics">
      <div class="default-header__skeleton__statistics__item">
        <app-placeholder width="20%" height="12px" margin-bottom="5px" />
        <app-placeholder height="10px" />
      </div>
      <div class="default-header__skeleton__statistics__item">
        <app-placeholder width="40px" height="40px" border-radius="100%" />
        <div>
          <app-placeholder width="100px" height="10px" />
          <app-placeholder width="100px" height="10px" margin-top="10px" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.default-header__skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  /* background-color: red; */

  &__title {
    width: 30%;
  }

  &__statistics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 10px;

    &__item {
      min-width: 229px;
      background: #f0f1f7;
      border-radius: 12px;
      padding: 20px 10px;
      margin: 0 7.5px;
      max-height: 200px;

      &:last-child {
        display: flex;
        align-items: center;
        column-gap: 10px;
        padding: 13px 10px;
      }
    }

    @include max-sm {
      column-gap: 10px;

      &__item {
        margin: 0;
      }
    }
  }

  @include max-sm {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 10px;
  }
}
</style>
